export const UNEXPECTED_ERROR_MESSAGE =
    'We are sorry, an unexpected error occurred';
